import { put, takeLatest } from 'redux-saga/effects';
import { getPhaseConfig, updatePhaseConfig } from '../../api/phases';
import parseAxiosError from '../../utils/helpers/parseAxiosError';
import { getPhaseConfigActionCreators, updatePhaseConfigActionCreators } from '../actions/phasesActionCreators';
import { getPhaseConfigConstants, updatePhaseConfigConstants } from '../constants/phasesConstants';

function* getPhaseConfigSaga() {
  yield put(getPhaseConfigActionCreators.pending());
  try {
    const result = yield getPhaseConfig();
    yield put(getPhaseConfigActionCreators.fulfilled(result.data.data));
  } catch (e) {
    yield put(getPhaseConfigActionCreators.rejected(parseAxiosError(e)));
  }
}

function* updatePhaseConfigSaga({ payload: { phases } }) {
  yield put(updatePhaseConfigActionCreators.pending());
  try {
    const result = yield updatePhaseConfig(phases);
    yield put(updatePhaseConfigActionCreators.fulfilled(result.data.data));
  } catch (e) {
    yield put(updatePhaseConfigActionCreators.rejected(parseAxiosError(e)));
  }
}

export default function* phasesSagas() {
  yield takeLatest(getPhaseConfigConstants.name, getPhaseConfigSaga);
  yield takeLatest(updatePhaseConfigConstants.name, updatePhaseConfigSaga);
}
